module.exports = __webpack_public_path__ + "img/uploading.c5e708f0.png";